<template>
    <div></div>
</template>

<script>
export default {
    mounted() {
        location.href = "//www" + this.$store.state.base_domain + "/mypage";
    }
}
</script>